import request from '@/utils/request';

const base = '/admin/complaint_feishu_groups';

// 本模块显式检查业务码，避免旧拦截器将 code=201 的校验失败当作保存成功。
async function call(config) {
  const response = await request(config);
  if (Number(response.data.code) !== 200) {
    throw new Error(response.data.message || '请求失败');
  }
  return response.data.data;
}

export function getComplaintGroupOptions() { return call({ url: `${base}/options`, method: 'get' }); }
export function getComplaintGroupInfo(params) { return call({ url: `${base}/chat_info`, method: 'get', params }); }
export function getComplaintGroupBots(params) { return call({ url: `${base}/bots`, method: 'get', params }); }
export function getComplaintGroups(params) { return call({ url: base, method: 'get', params }); }
export function getComplaintGroup(id) { return call({ url: `${base}/${id}`, method: 'get' }); }
export function saveComplaintGroup(data) {
  const { id, ...payload } = data;
  delete payload.group_name; // 后端按 Chat ID 获取最新群名，不提交客户端名称快照。
  // 关联游戏创建后只读，编辑不重新提交名称快照或游戏列表。
  if (id) delete payload.tag_ids;
  return call({ url: base + (id ? `/${id}` : ''), method: id ? 'put' : 'post', data: payload });
}
export function setComplaintGroupStatus(id, status) {
  return call({ url: `${base}/${id}/status`, method: 'put', data: { status } });
}
